import axios, { AxiosError } from "axios"

type response = { error?: string; message?: string }

export const createCommunity = async (
  name: string,
  description: string,
  img_url: string,
  owner_user_id: string,
  game_ids: string[] | null,
  is_private: boolean,
): Promise<response> => {
  try {
    const res = await axios.post<response>(`/communities`, {
      name,
      description,
      img_url,
      owner_user_id,
      game_ids,
      is_private: is_private ? 1 : 0,
    })
    return res.data
  } catch (error) {
    return { error: error?.toString(), message: (error as AxiosError)?.response?.data?.message }
  }
}
